module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAYAAAC9vt6cAAAAyklEQVR42pWSMQvCMBCFI67+rkRBx+LuD9BeRnVwU2d1FHQQ0TFXZ0cXf5HQxj5L7Vkw4sGDcO99l4RERddZyzg6QZE/N9WPQsYwHTTTEazSjm7axf4lpp33vvENhmc43ov8XXWYeprjR9k0bNffBuiENm8YzMV2C4Nt3zhKSzNfL+qwYbsUfgqmNt0O8qkZAoXspPTaTFOxc4bsB1wF7RCh6jo0gmQPGRUqk9BY7iZheEFYHHkOQAo99U/hNcRVVoFo8M23UOhvPAHBW7F8PnLwWgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./resources/images/arrow-down_2x.png
// module id = 957
// module chunks = 0